"use client"

import LeftSidebar from "@/(admin)/modules/ui-builder/config/themes/tamda-foods/StoreInfo/components/LeftSidebar"
import RightSidebar from "@/(admin)/modules/ui-builder/config/themes/tamda-foods/StoreInfo/components/RightSidebar"
import { useUIBuilderLocaleStore } from "@/(admin)/modules/ui-builder/store/useUIBuilderLocaleStore"
import { getFixedT } from "@/languages/i18n"
import { ComponentConfig } from "@measured/puck"
import { useParams } from "next/navigation"
import { twMerge } from "tailwind-merge"
import { useStores } from "../../../../../../../hook/useStores"
import { StoreInfoSkeleton } from "./components/StoreInfoSkeleton"
import { TransformedStoreItem } from "./type"
import { transformStoreData } from "./utils/utils"

export interface StoreInfoProps {
    title?: string
    className?: string
}

const renderStore = (store: TransformedStoreItem, index: number, locale?: string) => {

    return (
        <div key={store.id || index} className="flex flex-col sm:flex-row sm:gap-[30px] gap-4 py-[26px] border-t border-[#0000001a]">
            <LeftSidebar store={store} locale={locale} />
            <RightSidebar store={store} locale={locale} />
        </div>
    )
}

export const RenderConfig: ComponentConfig<StoreInfoProps> = {
    render: ({ title, className }) => {
        const params = useParams()
        const storeLocale = useUIBuilderLocaleStore(state => state.locale)
        const locale = (params?.locale as string) || storeLocale || "vi"
        const t = getFixedT(locale)
        const { stores: rawStores, loading } = useStores({ pageSize: 20 }, locale)
        const stores = transformStoreData(rawStores)

        if (loading) {
            return (
                <div className={twMerge("w-full", className)}>
                    <div className="max-w-[1304px] sm:px-2 px-4 mx-auto flex flex-col gap-4">
                        <StoreInfoSkeleton />
                    </div>
                </div>
            )
        }

        if (!stores || stores.length === 0) {
            return (
                <div className={twMerge("w-full", className)}>
                    <div className="max-w-[1304px] sm:px-2 px-4 mx-auto flex flex-col gap-4">
                        <div className="text-center py-8">{t("No stores available")}</div>
                    </div>
                </div>
            )
        }

        return (
            <div className={twMerge("w-full", className)}>
                <div className="max-w-[1304px] sm:px-2 px-4 mx-auto flex flex-col">
                    {title && <h2 className="text-xl leading-[31px] font-bold text-[#333333] uppercase mt-[60px] pb-4">{title}</h2>}
                    {[...stores].reverse().map((store, index) => renderStore(store, index, locale))}
                </div>
            </div>
        )
    },
}

